
export default{
  resourceUrl:'https://zhongbei2025.oss-cn-beijing.aliyuncs.com/'
}